import React from 'react';

export default function CloudMigrationIcon({ className = '' }) {
  return (
    <div className={`cloudGroup w-12 h-12 ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 41"
        fill="none"
        className="w-full h-full"
      >
        {/* 클라우드 본체 */}
        <path
          className="cloud"
          d="M11.4697 26.0145C7.36342 26.0145 4.03467 22.8103 4.03467 18.8573C4.03467 14.9059 7.36342 11.7017 11.4697 11.7017C12.0971 8.8886 14.3338 6.5928 17.3369 5.67799C20.3383 4.76478 23.6527 5.36986 26.0284 7.27451C28.404 9.17438 29.48 12.0753 28.8542 14.8883H30.4347C33.4889 14.8883 35.9651 17.3789 35.9651 20.4538C35.9651 23.5303 33.4889 26.0209 30.4332 26.0209H11.4697"
          fill="#1581FC"
        />

        {/* 플러스 아이콘들 */}
        <path
          className="plus plus1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 27.8585H13V34.1669H6.08337V36.1669H13H15V34.1669V27.8585Z"
          fill="#F8FBFF"
        />
        <path
          className="plus plus2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 27.8585H21V36.1669H19V27.8585Z"
          fill="#F8FBFF"
        />
        <path
          className="plus plus3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25 27.8585H27V34.1669H33.9166V36.1669H27H25V34.1669V27.8585Z"
          fill="#F8FBFF"
        />
      </svg>
    </div>
  );
}
